import React from "react";

/**
 * ChipGroup — a set of mutually exclusive chips.
 * `options` = [{ value, label }, ...]
 * On mobile: 2 columns; on ≥sm: 5 in a row.
 */
export function ChipGroup({ value, onChange, options, testIdPrefix }) {
  return (
    <div
      className="grid grid-cols-2 sm:grid-cols-5 gap-2"
      role="radiogroup"
      data-testid={`${testIdPrefix}-chips`}
    >
      {options.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            type="button"
            key={opt.value}
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt.value)}
            data-testid={`${testIdPrefix}-chip-${opt.value}`}
            className={`px-3 py-3 rounded-2xl text-[13px] font-medium transition-all duration-200 active:scale-[0.98] ${
              active
                ? "bg-[#F4C95D] text-[#0F172A] shadow-[0_8px_24px_-14px_rgba(244,201,93,0.9)]"
                : "bg-white/[0.03] border border-white/10 text-white/75 hover:text-white hover:bg-white/[0.06] hover:border-white/20"
            }`}
            style={{ letterSpacing: "-0.005em" }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
